<template>
    <v-container>
        <v-row>
            <v-spacer cols="auto"></v-spacer>
            <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 10">
                <span class="headline font-weight-thin font-italic">Frequently Asked Questions</span>
                <v-divider></v-divider>
                <v-breadcrumbs :items="categoryBreadcrumbs" ref="breadcrumbs">
                    <template v-slot:item="{ item }">
                        <v-breadcrumbs-item
                                            :to="item.to"
                                            :disabled="category === item.name"
                                            :exact="item.exact">
                            {{ item.text[0].charAt(0).toUpperCase() + item.text[0].slice(1)}}
                            {{ $vuetify.breakpoint.mobile ? '': item.text[1] }}
                        </v-breadcrumbs-item>
                    </template>
                    <template v-slot:divider>
                        <v-icon>{{ mdiChevronRight }}</v-icon>
                    </template>
                </v-breadcrumbs>
                <v-row justify="center">
                    <v-expansion-panels :value="expanded" accordian inset>
                        <v-expansion-panel
                                           v-for="(categoryFaqs, categoryName) in faqs"
                                           @change="changeRoute(categoryName)"
                                           :key="categoryName">
                            <v-expansion-panel-header>{{ categoryName.charAt(0).toUpperCase() + categoryName.slice(1) }}</v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-expansion-panels :value="expandedAnswer" accordian inset>
                                    <v-expansion-panel
                                                       v-for="faq in categoryFaqs" :key="faq.id">
                                        <v-expansion-panel-header>
                                            <template slot-scope="{ open }">
                                                <div class="d-flex align-center" :style="open ? 'font-size: larger' : ''" v-bind:class="questionHeaderClass(open)">
                                                    {{ faq.question }}
                                                    <div class="ml-4" v-if="open">
                                                        <bnft-share-menu :url="`https://${tld}/faq?category=${categoryName}&id=${faq.id}`" @copy="copy(`https://${tld}/faq?category=${categoryName}&id=${faq.id}`, faq.id)">
                                                            <!-- @mouseover="copy(`https://${tld}/faq?category=${categoryName}&id=${faq.id}`, faq.id)" -->
                                                            <v-icon small :id="`faqId-${faq.id}`">share</v-icon>
                                                        </bnft-share-menu>
                                                        <v-tooltip v-model="tooltip[`${faq.id}`]" :attach="`#faqId-${faq.id}`">
                                                            <span class="text-caption">Copied</span>
                                                        </v-tooltip>
                                                    </div>
                                                </div>
                                            </template>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content v-bind:class="{ 'mobileFont': $vuetify.breakpoint.mobile }">
                                            <v-img max-height="300" class="mb-4" v-if="faq.image" :src="faq.image"></v-img>
                                            <div class="faq-answer" v-html="faq.answer"></div>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>
<style>
.faq-answer img {
    max-height: 600px;
    width: auto;
}
table {
    margin: 20px auto;
}
td {
    padding: 0 20px 0 20px;
}
td:nth-child(2) {
    background: #ffebee;
}
td:nth-child(3) {
    background: #fafafa;
}
blockquote {
    font-family: "Times New Roman", Times, serif;
    font-size: x-large;
    background: #f9f9f9;
    border-left: 10px solid #ccc;
    margin: 0.5em 10px;
    padding: 0 10px;
    quotes: '"\201C" "\201D" "\2018" "\2019"';
    padding: 10px 20px;
    line-height: 1.4;
}

blockquote:before {
    content: open-quote;
    display: inline;
    height: 0;
    line-height: 0;
    left: -10px;
    position: relative;
    top: 30px;
    color: #ccc;
    font-size: 3em;
}
</style>

<script>
import App from "../App";
import { mdiChevronRight, mdiFrequentlyAskedQuestions } from "@mdi/js";
import { marked } from "marked";
import BnftShareMenu from "./BnftShareMenu.vue";

marked.setOptions({
    smartypants: true,
});
export default {
    name: "ComponentName",
    props: {
        msg: String,
    },
    mixins: App.mixins.filter((mixin) => mixin.name === "copy"),
    components: {
        BnftShareMenu,
    },
    computed: {
        category: function () {
            return this.$route.query.category === undefined
                ? "general"
                : this.$route.query.category;
        },
        categoryBreadcrumbs: function () {
            let mapped = this.categories
                ? this.categories.map((category) => ({
                      name: category,
                      text: [
                          `${
                              category.charAt(0).toUpperCase() +
                              category.slice(1)
                          }`,
                          " Questions",
                      ],
                      to: `faq?category=${category}`,
                      exact: true,
                  }))
                : [];
            return mapped;
        },
        expanded: function () {
            return this.categories.findIndex((name) => name === this.category);
        },
        expandedAnswer: function () {
            const question = this.faqs[this.category]
                ? Object.values(this.faqs[this.category])
                : [];
            const { id } = this.$route.query;
            if (!id || !question || !question.length) return 0;
            return question.findIndex((question) => question.id === id);
        },
    },
    watch: {
        category: function (newCategory) {
            if (
                Object.values(this.faqs[newCategory]).length === 0 &&
                !this.requests[newCategory]
            )
                this.getCategoryQuestions(newCategory);
            return newCategory;
        },
    },
    methods: {
        getCategoryQuestions: async function (category) {
            let self = this;

            if (!category) category = self.category;
            if (self.requests[category]) return;
            self.requests[category] = true;
            let faqs = await self.$ghost.getFAQs(category);
            faqs = faqs.map((faq) => {
                self.$set(self.tooltip, faq.id, false);
                return {
                    id: faq.id,
                    question: faq.q,
                    answer: faq.a
                        ? marked.parse(faq.a)
                        : `We're still working on this question.  Please check back later.`,
                    image: faq.image,
                };
            });
            this.faqs[category] = Object.assign({}, this.faqs[category], faqs);
            this.faqs = Object.assign({}, this.faqs);
        },
        changeRoute: function (category) {
            let regex = new RegExp(`\\?category=${category}`);
            if (!this.$route.fullPath.match(regex))
                this.$router.replace(`/faq?category=${category}`);
        },
        questionHeaderClass(open) {
            return {
                "font-weight-light": !open,
                "font-italic": open,
            };
        },
    },
    mounted() {
        let self = this;
        new Promise((resolve) => {
            self.$ghost.getFAQsMeta().then((meta) => {
                self.$set(self, "categories", meta.categories);
                self.categories.map((category) => {
                    if (!self.faqs[category]) self.faqs[category] = [];
                });
                this.getCategoryQuestions();
                resolve();
            });
        });
    },
    data() {
        return {
            faqs: {},
            categories: [],
            requests: {},
            mdiChevronRight,
            mdiFrequentlyAskedQuestions,
        };
    },
};
</script>
